<!--
 * @Description:完善密码
 * @Date: 2023-12-12 15:17:18
 -->
<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :center="true"
    :title="title"
    :visible.sync="dialogVisible"
    :width="width"
  >
    <el-form
      :model="resetForm"
      status-icon
      :rules="rules"
      ref="resetForm"
      label-width="100px"
      class="demo-resetForm"
    >
      <el-form-item label="输入密码：" prop="pass">
        <el-input
          style="width:380px;"
          placeholder="输入密码"
          type="password"
          v-model="resetForm.pass"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="再次输入：" prop="checkPass">
        <el-input
          style="width:380px;"
          :placeholder="placeholders"
          type="password"
          v-model="resetForm.checkPass"
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="skip">{{ cancelText }}</el-button>
      <el-button :loading="isLoading" type="primary" @click="confirm">
        {{ confirmText }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisibles: {
      type: Boolean,
      default: false
    },
    titles: {
      type: String,
      default: '提示'
    },
    widths: {
      type: String || Number,
      default: '550px'
    },
    confirmTexts: {
      type: String,
      default: '确定'
    },
    cancelTexts: {
      type: String,
      default: '取消'
    },
    placeholders: {
      type: String,
      default: '与输入密码保持一致'
    }
  },
  components: {},
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写'));
      } else if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{4,16}$/.test(value)) {
        callback('密码只能使用数字和字母组合，4-16 位');
      } else {
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写'));
      } else if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{4,16}$/.test(value)) {
        callback('密码只能使用数字和字母组合，4-16 位');
      } else if (value !== this.resetForm.pass) {
        callback(new Error('两次输入密码不一致，请重新填写'));
      } else {
        callback();
      }
    };

    return {
      isLoading: false,
      confirmText: this.confirmTexts,
      title: this.titles,
      width: this.widths,
      dialogVisible: this.dialogVisibles,
      cancelText: this.cancelTexts,
      resetForm: { pass: '', checkPass: '' },
      rules: {
        pass: [{ validator: validatePass, trigger: 'blur' }],
        checkPass: [{ validator: validatePass2, trigger: 'blur' }]
      }
    };
  },
  computed: {},
  watch: {},
  methods: {
    confirm() {
      this.$refs['resetForm'].validate(valid => {
        if (valid) {
          this.isLoading = true;
          let obj = {
            isShowDialog: this.showDialog,
            showIsLoading: this.showIsLoading,
            resetForm: this.resetForm
          };
          this.$emit('confirm', obj);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    showDialog() {
      this.isLoading = false;
      this.dialogVisible = false;
    },
    showIsLoading() {
      this.isLoading = false;
    },
    skip() {
      if (this.cancelTexts == '跳过') {
        this.$emit('skip');
        this.dialogVisible = false;
        return;
      }
      this.dialogVisible = false;
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
::v-deep.el-form-item {
  display: block;
  justify-content: flex-end;
  .el-input__suffix {
    display: none;
  }
}
//@import url(); 引入公共css类
</style>
